export default __webpack_public_path__ + "static/media/case_study_3.4847cbbd.jpg";